<template>
    <div class="paddingLeftRight">
        <div class="slider">
            <el-slider v-model="lrConfig.val" :max="100"></el-slider>
        </div>
        <div class="input">
            <el-input v-model="lrConfig.val" size="small"></el-input>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{

        }
    },
    props:{
        lrConfig:{
            type: Object,
            default: {}
        }
    },
    methods:{

    }
}
</script>

<style scoped lang="scss">
    .paddingLeftRight{
        width: 100%;
        height: 38px;
        margin: 10px 0;
        display: flex;
        align-items: center;
        .slider{
            flex: 1;
        }
        .input{
            flex: 1;
            margin-left: 10px;
        }
    }
</style>